<template>
  <div>
    <p class="title">{{ $t('member.tab.classTicket.usageStatistic') }}</p>
    <BaseTable :data="displayData">
      <BaseElTableColumn :label="$t('member.tab.classTicket.remainAvailable')" prop="remain" align="center" />
      <BaseElTableColumn :label="$t('member.tab.classTicket.totalCount')" prop="availableTimes" align="center" />
      <BaseElTableColumn :label="$t('member.tab.classTicket.preDeducted')" prop="bookTimes" align="center" />
      <BaseElTableColumn :label="$t('member.tab.classTicket.gifted')" prop="giveTimes" align="center" />
    </BaseTable>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { get } from 'lodash'

export default defineComponent({
  name: 'UseClassTicketRecordStatistic',
  props: {
    record: { type: Object, default: () => ({}) },
  },
  setup (props, { emit }) {
    const displayData = computed(() => {
      return [{
        remain: get(props.record, 'availableUseTimes'),
        availableTimes: get(props.record, 'availableTimes'),
        bookTimes: get(props.record, 'bookedTimes'),
        giveTimes: get(props.record, 'giveTimes'),
      }]
    })
    return { displayData }
  },
})

</script>

<style scoped lang="postcss">
.title {
  @apply font-medium text-primary-100 text-normal pb-[10px];
}
</style>
